<template v-if="card_s">
  <div class="card_s">
    <a class="alp" :href="card_s.link">
      <div class="thumb"><img :src="card_s.img" alt=""></div>
      <div class="desc">
        <p class="ttl txt-overflow" ref="tit" v-html="card_s.title"></p>
        <div class="info">発表日：{{ card_s.result }}</div>
      </div>
    </a>
  </div>
</template>

<style scoped lang="scss">
@mixin flex($jc: space-between) {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  justify-content: $jc;
}
$fontcolor: #333;

.card_s {
  margin-top: 17px;
  margin-right: 1.76%;
  &:nth-of-type(4n) {
    margin-right: 0;
  }
  a {
    display: block;
  }
    width: 23.674%;
    background: #fff;
  img {
    width: 96.6%;
    margin: 0 auto;
    padding-top: 1.7%;
    display: block;
  }
  .desc {
    padding-top: 18px;
    width: 82%;
    margin: 0 auto;
    .ttl {
      font-size: 14px;
      font-weight: bold;
      line-height: 1.6;
      color: $fontcolor;
      height: 3.2em;
      box-sizing: content-box;
      padding-bottom: 20px;
      border-bottom: 1px solid #ddd;
    }
    .info {
      padding: 10px 0;
      line-height: 1;
      font-size: 10px;
      font-weight: 500;
      color: $fontcolor;
      text-align: center;
        margin: 0 -5%;
    }
  }
  @media only screen and (max-width: 750px) {
    margin-top: 4%;
    margin-right: 0;
    width: 48%;
    .desc {
      width: 86%;
      padding-top: 3.8vw;
      .ttl {
        font-size: 0.9rem;
     height: 3.3em;
     padding-bottom: 3.2vw;
        }
      .info {
        font-size: 0.8rem;
        margin-top: 3.8vw;
        padding: 1.5vw 0;
        margin: 0 -4.2vw 0 -3.8vw;
      }
    }
  }
}

</style>

<script>
var moment = require("moment");
import _ from 'lodash'
import $ from 'jquery'
import ComponentUtils from "../utils/ComponentUtils.js";
export default {
  props: ["data", "i"],
  data() {
    return {
      keyParam: null
    };
  },
  name: "card_s",
  filters: {
    moment: function(date) {
      return moment(date).format("YYYY年M月D日");
    },
    day: function(date) {
      moment.locale('ja');
      return moment(date).format("（ddd）");
    }
  },
  computed: {
    card_s() {
      return this.data || {};
    }
  },
  mounted: function() {
    this.$nextTick(() => {
      this.txtOverflows()
      setTimeout(() => {
        this.txtOverflows()
      }, 1100)
    })
    $(window).resize(this.txtOverflows)
  },
  methods: _.assign({
    txtOverflows () {
      this.txtOverflow($(this.$refs.tit));
    }
  }, ComponentUtils)
};
</script>
